import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.json.stringify.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getClient, getCurrentScope } from '../currentScopes.js';
import { DEBUG_BUILD } from '../debug-build.js';
import { createSpanEnvelope } from '../envelope.js';
import { getMetricSummaryJsonForSpan } from '../metrics/metric-summary.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, SEMANTIC_ATTRIBUTE_PROFILE_ID, SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME } from '../semanticAttributes.js';
import { logger } from '../utils-hoist/logger.js';
import { dropUndefinedKeys } from '../utils-hoist/object.js';
import { generateTraceId, generateSpanId } from '../utils-hoist/propagationContext.js';
import { timestampInSeconds } from '../utils-hoist/time.js';
import { TRACE_FLAG_SAMPLED, TRACE_FLAG_NONE, spanTimeInputToSeconds, getStatusMessage, getRootSpan, spanToJSON, getSpanDescendants, spanToTransactionTraceContext } from '../utils/spanUtils.js';
import { getDynamicSamplingContextFromSpan } from './dynamicSamplingContext.js';
import { logSpanEnd } from './logSpans.js';
import { timedEventsToMeasurements } from './measurement.js';
import { getCapturedScopesOnSpan } from './utils.js';
var MAX_SPAN_COUNT = 1000;

/**
 * Span contains all data about a span
 */
var SentrySpan = /*#__PURE__*/function () {
  /** Epoch timestamp in seconds when the span started. */

  /** Epoch timestamp in seconds when the span ended. */

  /** Internal keeper of the status */

  /** The timed events added to this span. */

  /** if true, treat span as a standalone span (not part of a transaction) */

  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  function SentrySpan() {
    var _objectSpread2;
    var spanContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SentrySpan);
    this._traceId = spanContext.traceId || generateTraceId();
    this._spanId = spanContext.spanId || generateSpanId();
    this._startTime = spanContext.startTimestamp || timestampInSeconds();
    this._attributes = {};
    this.setAttributes(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'manual'), _defineProperty(_objectSpread2, SEMANTIC_ATTRIBUTE_SENTRY_OP, spanContext.op), _objectSpread2), spanContext.attributes));
    this._name = spanContext.name;
    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    this._events = [];
    this._isStandaloneSpan = spanContext.isStandalone;

    // If the span is already ended, ensure we finalize the span immediately
    if (this._endTime) {
      this._onSpanEnded();
    }
  }

  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  _createClass(SentrySpan, [{
    key: "addLink",
    value: function addLink(_link) {
      return this;
    }

    /**
     * This should generally not be used,
     * but it is needed for being compliant with the OTEL Span interface.
     *
     * @hidden
     * @internal
     */
  }, {
    key: "addLinks",
    value: function addLinks(_links) {
      return this;
    }

    /**
     * This should generally not be used,
     * but it is needed for being compliant with the OTEL Span interface.
     *
     * @hidden
     * @internal
     */
  }, {
    key: "recordException",
    value: function recordException(_exception, _time) {
      // noop
    }

    /** @inheritdoc */
  }, {
    key: "spanContext",
    value: function spanContext() {
      var spanId = this._spanId,
        traceId = this._traceId,
        sampled = this._sampled;
      return {
        spanId: spanId,
        traceId: traceId,
        traceFlags: sampled ? TRACE_FLAG_SAMPLED : TRACE_FLAG_NONE
      };
    }

    /** @inheritdoc */
  }, {
    key: "setAttribute",
    value: function setAttribute(key, value) {
      if (value === undefined) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
      } else {
        this._attributes[key] = value;
      }
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setAttributes",
    value: function setAttributes(attributes) {
      var _this = this;
      Object.keys(attributes).forEach(function (key) {
        return _this.setAttribute(key, attributes[key]);
      });
      return this;
    }

    /**
     * This should generally not be used,
     * but we need it for browser tracing where we want to adjust the start time afterwards.
     * USE THIS WITH CAUTION!
     *
     * @hidden
     * @internal
     */
  }, {
    key: "updateStartTime",
    value: function updateStartTime(timeInput) {
      this._startTime = spanTimeInputToSeconds(timeInput);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setStatus",
    value: function setStatus(value) {
      this._status = value;
      return this;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "updateName",
    value: function updateName(name) {
      this._name = name;
      this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'custom');
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "end",
    value: function end(endTimestamp) {
      // If already ended, skip
      if (this._endTime) {
        return;
      }
      this._endTime = spanTimeInputToSeconds(endTimestamp);
      logSpanEnd(this);
      this._onSpanEnded();
    }

    /**
     * Get JSON representation of this span.
     *
     * @hidden
     * @internal This method is purely for internal purposes and should not be used outside
     * of SDK code. If you need to get a JSON representation of a span,
     * use `spanToJSON(span)` instead.
     */
  }, {
    key: "getSpanJSON",
    value: function getSpanJSON() {
      return dropUndefinedKeys({
        data: this._attributes,
        description: this._name,
        op: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP],
        parent_span_id: this._parentSpanId,
        span_id: this._spanId,
        start_timestamp: this._startTime,
        status: getStatusMessage(this._status),
        timestamp: this._endTime,
        trace_id: this._traceId,
        origin: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
        _metrics_summary: getMetricSummaryJsonForSpan(this),
        profile_id: this._attributes[SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: this._attributes[SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: timedEventsToMeasurements(this._events),
        is_segment: this._isStandaloneSpan && getRootSpan(this) === this || undefined,
        segment_id: this._isStandaloneSpan ? getRootSpan(this).spanContext().spanId : undefined
      });
    }

    /** @inheritdoc */
  }, {
    key: "isRecording",
    value: function isRecording() {
      return !this._endTime && !!this._sampled;
    }

    /**
     * @inheritdoc
     */
  }, {
    key: "addEvent",
    value: function addEvent(name, attributesOrStartTime, startTime) {
      DEBUG_BUILD && logger.log('[Tracing] Adding an event to span:', name);
      var time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || timestampInSeconds();
      var attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
      var event = {
        name: name,
        time: spanTimeInputToSeconds(time),
        attributes: attributes
      };
      this._events.push(event);
      return this;
    }

    /**
     * This method should generally not be used,
     * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
     * USE THIS WITH CAUTION!
     * @internal
     * @hidden
     * @experimental
     */
  }, {
    key: "isStandaloneSpan",
    value: function isStandaloneSpan() {
      return !!this._isStandaloneSpan;
    }

    /** Emit `spanEnd` when the span is ended. */
  }, {
    key: "_onSpanEnded",
    value: function _onSpanEnded() {
      var client = getClient();
      if (client) {
        client.emit('spanEnd', this);
      }

      // A segment span is basically the root span of a local span tree.
      // So for now, this is either what we previously refer to as the root span,
      // or a standalone span.
      var isSegmentSpan = this._isStandaloneSpan || this === getRootSpan(this);
      if (!isSegmentSpan) {
        return;
      }

      // if this is a standalone span, we send it immediately
      if (this._isStandaloneSpan) {
        if (this._sampled) {
          sendSpanEnvelope(createSpanEnvelope([this], client));
        } else {
          DEBUG_BUILD && logger.log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
          if (client) {
            client.recordDroppedEvent('sample_rate', 'span');
          }
        }
        return;
      }
      var transactionEvent = this._convertSpanToTransaction();
      if (transactionEvent) {
        var scope = getCapturedScopesOnSpan(this).scope || getCurrentScope();
        scope.captureEvent(transactionEvent);
      }
    }

    /**
     * Finish the transaction & prepare the event to send to Sentry.
     */
  }, {
    key: "_convertSpanToTransaction",
    value: function _convertSpanToTransaction() {
      var _this2 = this;
      // We can only convert finished spans
      if (!isFullFinishedSpan(spanToJSON(this))) {
        return undefined;
      }
      if (!this._name) {
        DEBUG_BUILD && logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
        this._name = '<unlabeled transaction>';
      }
      var _getCapturedScopesOnS = getCapturedScopesOnSpan(this),
        capturedSpanScope = _getCapturedScopesOnS.scope,
        capturedSpanIsolationScope = _getCapturedScopesOnS.isolationScope;
      var scope = capturedSpanScope || getCurrentScope();
      var client = scope.getClient() || getClient();
      if (this._sampled !== true) {
        // At this point if `sampled !== true` we want to discard the transaction.
        DEBUG_BUILD && logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
        if (client) {
          client.recordDroppedEvent('sample_rate', 'transaction');
        }
        return undefined;
      }

      // The transaction span itself as well as any potential standalone spans should be filtered out
      var finishedSpans = getSpanDescendants(this).filter(function (span) {
        return span !== _this2 && !isStandaloneSpan(span);
      });
      var spans = finishedSpans.map(function (span) {
        return spanToJSON(span);
      }).filter(isFullFinishedSpan);
      var source = this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];

      // remove internal root span attributes we don't need to send.
      /* eslint-disable @typescript-eslint/no-dynamic-delete */
      delete this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
      spans.forEach(function (span) {
        span.data && delete span.data[SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
      });
      // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete

      var transaction = _objectSpread({
        contexts: {
          trace: spanToTransactionTraceContext(this)
        },
        spans:
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        spans.length > MAX_SPAN_COUNT ? spans.sort(function (a, b) {
          return a.start_timestamp - b.start_timestamp;
        }).slice(0, MAX_SPAN_COUNT) : spans,
        start_timestamp: this._startTime,
        timestamp: this._endTime,
        transaction: this._name,
        type: 'transaction',
        sdkProcessingMetadata: _objectSpread({
          capturedSpanScope: capturedSpanScope,
          capturedSpanIsolationScope: capturedSpanIsolationScope
        }, dropUndefinedKeys({
          dynamicSamplingContext: getDynamicSamplingContextFromSpan(this)
        })),
        _metrics_summary: getMetricSummaryJsonForSpan(this)
      }, source && {
        transaction_info: {
          source: source
        }
      });
      var measurements = timedEventsToMeasurements(this._events);
      var hasMeasurements = measurements && Object.keys(measurements).length;
      if (hasMeasurements) {
        DEBUG_BUILD && logger.log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
        transaction.measurements = measurements;
      }
      return transaction;
    }
  }]);
  return SentrySpan;
}();
function isSpanTimeInput(value) {
  return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}

// We want to filter out any incomplete SpanJSON objects
function isFullFinishedSpan(input) {
  return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}

/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */
function isStandaloneSpan(span) {
  return span instanceof SentrySpan && span.isStandaloneSpan();
}

/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */
function sendSpanEnvelope(envelope) {
  var client = getClient();
  if (!client) {
    return;
  }
  var spanItems = envelope[1];
  if (!spanItems || spanItems.length === 0) {
    client.recordDroppedEvent('before_send', 'span');
    return;
  }

  // sendEnvelope should not throw
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  client.sendEnvelope(envelope);
}
export { SentrySpan };